import React from 'react';
import type { ManualCheck } from '../../types/manualCheck';
import { formatDate } from '../../utils/dateUtils';

interface ManualChecksTableProps {
  checks: ManualCheck[];
  onEdit: (check: ManualCheck) => void;
  onDelete: (check: ManualCheck) => void;
}

/**
 * R16 Task A: recent-entries table for the master check log. Kept
 * intentionally minimal (presentational only); the page component owns
 * fetching + filter state.
 */
export const ManualChecksTable: React.FC<ManualChecksTableProps> = ({
  checks,
  onEdit,
  onDelete,
}) => {
  if (!checks.length) {
    return (
      <div className="text-sm text-gray-500 italic p-4">
        No manual checks match the current filters.
      </div>
    );
  }
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-100">
          <tr className="text-left">
            <th className="px-3 py-2">Date</th>
            <th className="px-3 py-2">Firm</th>
            <th className="px-3 py-2">Salesman</th>
            <th className="px-3 py-2 text-right">Amount</th>
            <th className="px-3 py-2 text-right">Payout %</th>
            <th className="px-3 py-2 text-right">Salesman Comm</th>
            <th className="px-3 py-2 text-right">House Comm</th>
            <th className="px-3 py-2"></th>
          </tr>
        </thead>
        <tbody>
          {checks.map((c) => (
            <tr key={c.id} className="border-t hover:bg-gray-50">
              <td className="px-3 py-2">{formatDate(c.check_date)}</td>
              <td className="px-3 py-2">{c.firm_name}</td>
              <td className="px-3 py-2">{c.salesman?.name ?? '—'}</td>
              <td className="px-3 py-2 text-right">${Number(c.amount).toFixed(2)}</td>
              <td className="px-3 py-2 text-right">
                {Number(c.payout_percentage).toFixed(2)}%
              </td>
              <td className="px-3 py-2 text-right text-blue-700">
                ${Number(c.salesman_commission).toFixed(2)}
              </td>
              <td className="px-3 py-2 text-right text-gray-700">
                ${Number(c.house_commission).toFixed(2)}
              </td>
              <td className="px-3 py-2 whitespace-nowrap text-right">
                <button
                  className="text-blue-600 hover:underline mr-2"
                  onClick={() => onEdit(c)}
                >
                  Edit
                </button>
                <button
                  className="text-red-600 hover:underline"
                  onClick={() => onDelete(c)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ManualChecksTable;
